import React from 'react'
import PropTypes from 'prop-types'
import constants from './constants'
import Placeholder from './Placeholder'
import ReactPlaceholder from 'react-placeholder'
import imagePlaceHolder from '@loyal_images/products/product_placeholder.png'

const ProductImageDonation = props => {
  var img
  var src
  var alt = ''
  switch (props.vendorId) {
    case constants.VENDOR.SMILES.ID:
      src = constants.VENDOR.SMILES.IMAGEURL
      alt = props.alt
      break
    case constants.VENDOR.SHELL.ID:
      src = constants.VENDOR.SHELL.IMAGEURL
      alt = props.alt
      break
    case constants.VENDOR.PAYBILLS.ID:
      src = constants.VENDOR.SHELL.IMAGEURL
      alt = props.alt
      break
    case constants.VENDOR.DONATION.ID:
      src = constants.VENDOR.DONATION.IMAGEURL
      alt = props.alt
      break
    case constants.VENDOR.CELLPHONERECHARGE.ID:
      var srcRecharge
      var altRecharge

      for (var property in constants.OPERATORS) {
        var operator = constants.OPERATORS[property]
        if (
          props.alt.toUpperCase().indexOf(operator.description.toUpperCase())
        ) {
          srcRecharge = operator.IMAGEURL
          altRecharge = operator.description
          break
        }
      }

      src = srcRecharge || constants.VENDOR.CELLPHONERECHARGE.IMAGEURL
      alt = altRecharge || props.alt
      break
    default:
      src = props.imageUrl
      alt = props.alt
      break
  }

  const imageDonation = {
    width: '70px'
  }

  img = <img src={src || imagePlaceHolder} alt={alt} className='border border-color-brand-1 radius p-1' style={imageDonation} />

  return (
    <ReactPlaceholder ready={props.ready} customPlaceholder={<Placeholder />}>
      {img}
    </ReactPlaceholder>
  )
}

ProductImageDonation.propTypes = {
  imageUrl: PropTypes.string,
  alt: PropTypes.string,
  vendorId: PropTypes.number,
  ready: PropTypes.bool
}

export default ProductImageDonation



// WEBPACK FOOTER //
// ./src/features/ProductImageDonation/ProductImageDonation.js